<div class="shell">
  <ec-top-bar class="shell__topbar"></ec-top-bar>

  <div class="shell__body">
    <ec-app-rail class="shell__rail"></ec-app-rail>

    <main class="shell__content">
      <router-outlet></router-outlet>
    </main>
  </div>
  <app-ai-sidebar></app-ai-sidebar>
</div>
